var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddMyPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddMyPlan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0450307,9.50003052 L15.6800085,4.86504728 C16.1066638,4.43839151 16.1066638,3.7466476 15.6800085,3.32005287 C15.2533533,2.89339709 14.5616712,2.89339709 14.1350159,3.32005287 L9.49997711,7.95509714 L4.86493828,3.31999183 C4.438283,2.89333606 3.74660095,2.89333606 3.31994568,3.31999183 C2.89335144,3.7466476 2.89335144,4.43839151 3.31994568,4.86498624 L7.95498451,9.49996948 L3.31994568,14.1350138 C2.89335144,14.5616695 2.89335144,15.2534134 3.31994568,15.6800082 C3.74660095,16.1066639 4.438283,16.1066639 4.86493828,15.6800082 L9.49997711,11.0449639 L14.1350159,15.6800082 C14.5616102,16.1066639 15.2533533,16.1066639 15.6800085,15.6800082 C16.1066638,15.2533524 16.1066638,14.5616695 15.6800085,14.1350138 L11.0450307,9.50003052 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icAddMyPlan",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(9.500000, 9.500000) rotate(-44.000000) translate(-9.500000, -9.500000) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddMyPlan);
export default __webpack_public_path__ + "static/media/icAddMyPlan.dba96cc33d7884f54ea90e653f8a8ac8.svg";
export { ForwardRef as ReactComponent };